import React, { useContext } from "react";
import styled from "styled-components";

import languagePack, { languageAction } from "../../Utils/language";
import globalContext from "../../Hooks/globalContext";

const Logo = styled.img`
  width: 180px;
`;

const SideBar = styled.div`
  width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.mainColor};
`;

const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 10px 5px;
  font-size: 40px;
  color: white;
`;

const MenuItem = styled.div`
  width: 100%;
  padding: 15px;
  color: white;
  font-size: 15px;
  cursor: pointer;
  :hover {
    opacity: 0.35;
  }
`;

const FocusedMenuItem = styled(MenuItem)`
  opacity: 0.35;
`;

const LanguageSelect = styled.select`
  position: absolute;
  width: 250px;
  bottom: 0px;
`;

const AdminSideBar = ({ page }) => {
  const { user, language } = useContext(globalContext);

  const selectOnChange = ({ target: { value } }) => {
    language.setState(value);
  };

  const MenuFactory = ({ text = "None", pageName = null }) => {
    const menuOnClick = () => {
      page.setState(pageName);
    };
    return page.state === pageName ? (
      <FocusedMenuItem onClick={menuOnClick}>{text}</FocusedMenuItem>
    ) : (
      <MenuItem onClick={menuOnClick}>{text}</MenuItem>
    );
  };

  return (
    <SideBar>
      <LogoWrapper>ADMIN</LogoWrapper>

      <MenuFactory pageName={"userList"} text={languagePack("유저 관리", language.state)} />
      <MenuFactory pageName={"lockupList"} text={languagePack("락업 로그", language.state)} />
      <MenuFactory pageName={"noticeList"} text={"공지사항 관리"} />
      {/* <MenuFactory pageName={"stakingList"} text={languagePack("스테이킹 로그", language.state)} /> */}
      {/* <MenuFactory pageName={"config"} text={languagePack("설정", language.state)} /> */}
    </SideBar>
  );
};

export default AdminSideBar;
